import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { NotifierService } from 'angular-notifier';
import * as XLSX from "xlsx";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-setting-home',
  templateUrl: './setting-home.component.html',
  styleUrls: ['./setting-home.component.scss']
})
export class SettingHomeComponent implements OnInit {
  modules: any[] = [];
  page = 1;
  pageSize = 10;
  constructor(
      private settingsService: SettingsService,
      private notifierService: NotifierService,
      private http: HttpClient
  ) { }

  ngOnInit() {
    this.settingsService.getModules().subscribe(res => {
          this.modules = res['result'].map(module => {
              module.settings = module.settings.map(setting => {

                  // 1. Convertir checkbox
                  if (setting.type === 'checkbox') {
                      try {
                          setting.value = JSON.parse(setting.value);
                      } catch (e) {
                          setting.value = false;
                      }
                  }

                  if (setting.type === 'select') {
                      try {
                          setting.value = Array.isArray(setting.value)
                              ? setting.value
                              : JSON.parse(setting.value || '[]');
                      } catch(e) {
                          setting.value = [];
                      }
                      this.loadSelectOptions(setting);
                  }
                  return setting;
              });

              return module;
          });
      });
  }
  validateJson(setting: any) {
    try {
      JSON.parse(setting.value);
      setting.jsonError = null;
    } catch (e) {
      setting.jsonError = (e as Error).message;
    }
  }
  updateSetting(module: any) {
      module.settings = module.settings.map(setting => {
          if (typeof setting.options === 'string') {
              try {
                  setting.options = JSON.parse(setting.options);
              } catch (e) {
                  console.warn('Options no es un JSON válido:', setting.options);
              }
          }

          return setting;
      });
    this.settingsService.updateModules(module).subscribe(res => {
      this.notifierService.notify('success', res['message']);
    });
  }
  onExcelImport(event: any, setting: any): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) return;

    const validExtensions = ['xls', 'xlsx'];
    const fileName = file.name.toLowerCase();
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);

    if (!validExtensions.includes(extension)) {
      this.notifierService.notify('danger', 'Please upload a valid Excel file (.xls or .xlsx).');
      input.value = '';
      return;
    }

    const validMimeTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];
    if (file.type && !validMimeTypes.includes(file.type)) {
      this.notifierService.notify('error', 'The file type is not supported. Please upload an Excel file.');
      input.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        const data: any = XLSX.utils.sheet_to_json(ws, { header: 1 });

        const codes = data.flat().filter((code: any) => !!code);
        setting.value = JSON.stringify(codes, null, 2);

        this.notifierService.notify('success', 'The upload of the Capital One BIN code file completed successfully.');
      } catch (error) {
        this.notifierService.notify('error', 'Error processing the Excel file. Please upload a valid Excel document.');
      } finally {
        input.value = '';
      }
    };

    reader.readAsBinaryString(file);
  }
  parseJson(json: string): any[] {
    try {
      return JSON.parse(json);
    } catch {
      return [];
    }
  }

  removeSetting(setting: any, index: number) {
    try {
      const arr = JSON.parse(setting.value);
      arr.splice(index, 1);
      setting.value = JSON.stringify(arr);
      const totalPages = Math.ceil(arr.length / this.pageSize);
      if (this.page > totalPages) {
        this.page = Math.max(1, totalPages);
      }
    } catch(e) {
      console.log(e)
      this.notifierService.notify('error', 'Failed to remove Capital One BIN code.');
    }
  }

  getPagedItems(setting: any) {
    const arr = this.parseJson(setting.value);
    const start = (this.page - 1) * this.pageSize;
    return arr.slice(start, start + this.pageSize);
  }
  prevPage() {
    if (this.page > 1) this.page--;
  }

  nextPage(setting: any) {
    const arr = this.parseJson(setting.value);
    if (this.page * this.pageSize < arr.length) this.page++;
  }
  addItem(setting: any, item: string) {
    const trimmed = item.trim();
    if (!trimmed) return;

    try {
      const arr = JSON.parse(setting.value || '[]');
      arr.unshift(trimmed);
      setting.value = JSON.stringify(arr);
    } catch (e) {
      console.error('Error parsing setting.value:', e);
      this.notifierService.notify('danger', 'Failed to add new Capital One BIN code.');
    }
  }
  loadSelectOptions(setting: any) {
        try {
            const options = JSON.parse(setting.options || '{}');
            const apiRoute = options.apiRoute;
            if(!apiRoute) return
            const url = environment.url + '/' + apiRoute;
            this.http.get(url).subscribe(
                (res: any) => {
                    const labelKey =
                        options.selectOption && options.selectOption.label
                            ? options.selectOption.label
                            : 'name';

                    const valueKey =
                        options.selectOption && options.selectOption.value
                            ? options.selectOption.value
                            : 'id';
                    setting.optionsList = res.result.map(item => ({
                        label: item[labelKey],
                        value: item[valueKey]
                    }));
                },
                err => {
                    console.error('Error loading select options:', err);
                    setting.optionsList = [];
                }
            );
        } catch (e) {
            console.error('Error parsing setting.options', e);
            setting.optionsList = [];
        }
    }


    protected readonly JSON = JSON;
}
